<template>
    <div class="message-alarm" @mouseenter="dropDown" @mouseleave="dropUp">
        <span class="message-alarm-title">
            <!-- <div class="bell"></div> -->
            <span class="unread"></span>
            <img class="bell" src="@/assets/img/icon/bell_green.svg" alt="">
        </span>
        <transition name="fade"> 
            <ul v-if="show"  @click="dropUp">
                <li>
                    <div class="icon">
                        <span class="unread"></span>
                        <img src="@/assets/img/component/alarm_message/announcement.svg" alt="">
                    </div>
                    <div class="message">
                        <span class="text">平台公告 公告內容文案</span>
                        <span class="time">3 小時前</span>
                    </div>
                </li>
                <li>
                    <div class="icon">
                        <!-- <span class="unread"></span> -->
                        <img src="@/assets/img/component/alarm_message/home.svg" alt="">
                    </div>
                    <div class="message">
                        <span class="text">小胖子的家 合約快到期，詢問房客是否續租</span>
                        <span class="time">3 小時前</span>
                    </div>
                </li>
                <li>
                    <div class="icon">
                        <span class="unread"></span>
                        <img src="@/assets/img/component/alarm_message/user.svg" alt="">
                    </div>
                    <div class="message">
                        <span class="text">王小明 已預訂了房源 小胖子的家</span>
                        <span class="time">3 小時前</span>
                    </div>
                </li>
                <div class="group">
                    <span class="setting">
                        <img src="@/assets/img/icon/setting_gray.svg" alt="">
                        設定
                    </span>
                    <span class="view-all">
                        <router-link :to="{ path: '/landlord/housestatus/member#通知'}">
                            查看全部
                        </router-link>
                    </span>
                </div>
            </ul>
        </transition> 
    </div>
</template>
<script>
export default {
    name: 'MessageAlarm',
    data () {
        return {
            show: 0,
        }
    },
    methods: {
        dropDown: function () {
            this.show = 1;
        },
        dropUp: function () {
            this.show = 0;
        },
    }
}
</script>
<style scoped lang="scss">
    .message-alarm{
        position: relative;
        margin-right: 30px;
        .unread{
            position: absolute;
            width: 6px;
            height: 6px;
            background-color: #ffd249;
            border-radius: 4px;
            top: 1px;
            right: 5px;
        }
        .message-alarm-title{
            .bell{
                width: 30px;
                height: 30px;
                // background: #ccc;
                // border-radius: 50px;
                margin-left: 30px;
            }
        }
        ul{
            position: absolute;
            right: 0px;
            width: 479px;
            border-radius: 4px;
            z-index: 9999;
            background: #fff;
            border: solid 1px #eeeeee;
            padding: 8px 0;
            li{
                display: flex;
                align-items: center;
                justify-items: center;
                border-bottom: 1px solid #f1f5f4;
                margin: 0 24px;
                padding: 16px 0;
                cursor: pointer;
                .icon{
                    position: relative;
                    display: flex;
                    align-items: center;
                    width: 40px;
                    height: 40px;
                    margin-right: 12px;
                    border-radius: 20px;
                    background-color: #f6f6f6;
                    .unread{
                        position: absolute;
                        width: 8px;
                        height: 8px;
                        background-color: #ffd249;
                        border-radius: 4px;
                        top: 2px;
                        right: 2px;
                    }
                    >img{
                        margin: 0 auto;
                    }
                }
                .message{
                    display: flex;
                    flex-direction: column;
                    .text{
                        margin-bottom: 4px;
                    }
                    .time{
                        color: #a8a5a4;
                    }
                }
            }
            li:nth-last-child(2){
                border-bottom: 0px;
            }
            .group{
                display: flex;
                align-items: center;
                padding: 12px 20px;
                border-top: 1px solid #f1f5f4;
                .setting{
                    display: flex;
                    align-items: center;
                    color: #a8a5a4;
                    margin-right: 2px;
                }
                .view-all{
                    position: absolute;
                    right: 20px;
                    >a{
                        color: #ff9275;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/MessageAlarm.vue